import {
  Box,
  List,
  ListItem,
  ListItemText,
  Paper,
  Typography,
} from "@material-ui/core";
import React from "react";

const RecommendationDisplay = ({ recommendations, filteredRecommendation }) => {
  const hasData =
    filteredRecommendation &&
    filteredRecommendation.length > 0 &&
    filteredRecommendation.some((key) => recommendations[key]);

  return (
    <Box component={Paper} p={2}>
      {hasData ? (
        filteredRecommendation.map((key) => (
          <RecommendationItem
            key={key}
            recommendationKey={key}
            data={recommendations[key]}
          />
        ))
      ) : (
        <Typography variant="body1" color="textSecondary" align="center">
          No data available
        </Typography>
      )}
    </Box>
  );
};

const RecommendationItem = ({ recommendationKey, data }) => {
  return (
    <Box mb={3}>
      <Typography variant="h6">
        {recommendationKey} (Score: {data.score} - {data.label})
      </Typography>

      {Object.entries(data.recommendations)
        .filter(([key]) => key !== "Score/Label To Display")
        .map(([key, value], index) => (
          <RecommendationDetail
            key={`${recommendationKey}-${index}`}
            title={key}
            content={value}
          />
        ))}
    </Box>
  );
};

const RecommendationDetail = ({ title, content }) => {
  return (
    <Box mt={2}>
      <Typography variant="body1" color="primary" gutterBottom>
        {title}
      </Typography>

      {Array.isArray(content) ? (
        <List dense>
          {content.map((item, idx) => (
            <ListItem key={idx}>
              <ListItemText primary={`• ${item}`} />
            </ListItem>
          ))}
        </List>
      ) : (
        <Typography variant="body2">{content}</Typography>
      )}
    </Box>
  );
};

export default RecommendationDisplay;
